import React, { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import API from "../../../api"
import { mapDispatchProps, mapStateToProps } from "store/store"
import { connect } from "react-redux"
import { ROUTES } from "routes"
import { isGlovv } from "constants/domains/domains"

const LectureLessonIndex: React.FC = (props: any) => {
  const { lectureId } = useParams<{ lectureId: string }>()

  const [lessons, setLessons] = useState([])
  const [lecture, setLecture] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    checkEnterPassword()
  }, [])

  useEffect(() => {
    const fetchLessons = async () => {
      try {
        const response = await API.LectureLesson.index(Number(lectureId), {
          mobile: props.preferences?.lectureUser?.mobile,
          name: props.preferences?.lectureUser?.name,
        })
        setLessons(response.data.lessons)
        setLecture(response.data.lecture)
      } catch (error) {
        console.error("레슨 목록을 가져오는 중 오류 발생:", error)
      }
    }

    fetchLessons()
  }, [lectureId])

  const handleGoBack = () => {
    navigate(ROUTES.LECTURE_INDEX.PATH, {
      replace: true,
    })
    window.scrollTo(0, 0)
  }

  const checkEnterPassword = async () => {
    try {
      console.log(props.preferences?.lectureUser)

      if (
        !props.preferences?.lectureUser ||
        !props.preferences?.lectureUser?.mobile ||
        !props.preferences?.lectureUser?.password
      ) {
        handleGoBack()
        return false
      }

      const response = await API.Lecture.password({
        domain: isGlovv() ? 'glovv' : 'oneulook',
        password: props.preferences?.lectureUser?.password
      })
      if (response.code == 200) {
        return true
      }
    } catch (error) {
      handleGoBack()
    }
  }

  const handleLessonClick = async (lessonId, chapterId) => {
    try {
      await API.Lecture.storeWatchHistory({
        brandToken: props.auth.token,
        lesson_id: lessonId,
        name: props.preferences?.lectureUser?.name,
        mobile: props.preferences?.lectureUser?.mobile,
      })

      await API.Lecture.storeWatchHistory({
        brandToken: props.auth.token,
        chapter_id: 1,
        name: props.preferences?.lectureUser?.name,
        mobile: props.preferences?.lectureUser?.mobile,
      })

      navigate(ROUTES.LECTURE_CHAPTER_INDEX.SHOW(lectureId, lessonId, chapterId), {
        state: { lessons, lecture },
      })
      window.scrollTo(0, 0)
    } catch (error) {
      if (error.data && error.data.errors) {
        const errorMessages = Object.values(error.data.errors).flat().join("\n")
        props.showModal({ text: `강의 시청 기록 저장 중 오류 발생\n${errorMessages}` })
      } else {
        props.showModal({ text: `강의 시청 기록 저장 중 오류 발생\n${error.message}` })
      }
    }
  }

  if (!lecture || !lessons) return <></>

  return (
    <div className="min-h-screen p-8">
      <div className="max-w-4xl mx-auto">
        <button onClick={handleGoBack} className="mb-4 flex items-center space-x-2 cursor-pointer">
          <img src={"/assets/icons/ic-arrow-go-back-gray.svg"} />
          <span className="text-[0.9375rem] text-[#999999] hover:text-black hover:font-bold">뒤로가기</span>
        </button>

        <h1 className="text-[48px] font-bold mb-[50px]">{lecture.title}</h1>
        {lessons.length > 0 ? (
          <ul className="space-y-2">
            <hr className="my-2 border-gray-300" />
            {lessons.map((lesson: any, index: number) => {
              const isWatching =
                lesson.histories &&
                lesson.histories.length &&
                lesson.histories[0].progress < 95 &&
                lesson.histories[0].progress > 0
              const isWatched = lesson.histories && lesson.histories.length && lesson.histories[0].progress >= 95

              return (
                <React.Fragment key={lesson.id}>
                  <li
                    className="bg-white p-3 cursor-pointer"
                    onClick={() => handleLessonClick(lesson.id, lesson.firstChapter.id)}
                  >
                    <div className="flex items-center">
                      <div className="mr-[20px]">
                        {isWatched ? (
                          <img src={"/assets/icons/ic-video-play-inactive.svg"} />
                        ) : (
                          <img src={"/assets/icons/ic-video-play-active.svg"} />
                        )}
                      </div>

                      <div className="flex items-center justify-between w-full">
                        <div className="flex items-center space-x-[10px]">
                          <span
                            className={`text-[1.375rem] font-bold 
                              ${isWatched ? "text-[#999999]" : ""}
                              ${isWatching ? "text-[#000000]" : ""}`}
                          >
                            {`${lesson.order}. ${lesson.title}`}
                          </span>
                          {isWatched ? (
                            <div
                              className={`flex items-center border rounded-[4px] px-[2px] text-[13px] font-semibold border-[#E8E8E8] text-[#999999]`}
                            >
                              <span>시청완료</span>
                            </div>
                          ) : null}
                          {isWatching ? (
                            <div
                              className={`flex items-center border rounded-[4px] px-[2px] text-[13px] font-semibold border-[#000000] text-[#000000]`}
                            >
                              <span>시청중</span>
                            </div>
                          ) : null}
                        </div>
                        {lesson.duration && (
                          <span className="ml-auto text-[#999999] text-[0.9375rem]">
                            {new Date(lesson.duration * 1000).toISOString().substr(11, 8)}
                          </span>
                        )}
                      </div>
                    </div>
                  </li>

                  {index < lessons.length - 1 && <hr className="my-2 border-gray-300" />}
                </React.Fragment>
              )
            })}
            <hr className="my-2 border-gray-300" />
          </ul>
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(LectureLessonIndex)
